// The still background behind the Ask HR page (not Admin), plus two strips of it that sit over
// the page in the gaps above the messages and below the question box (base.css). Decorative, so
// hidden from screen readers.

import image from "../assets/ask-hr-background-static-muted.png";

export function Backdrop() {
  const style = { backgroundImage: `url(${image})` };
  return (
    <>
      <div className="backdrop" aria-hidden="true" style={style} />
      <div className="backdrop-strip top" aria-hidden="true" style={style} />
      <div className="backdrop-strip bottom" aria-hidden="true" style={style} />
    </>
  );
}
